import BrandFormReducer from "@tCooneyBrothers/Store/Data/Brand/BrandFormReducer";
import CustomerPartNumberReducer from "@tCooneyBrothers/Store/Data/CustomerPartNumber/CustomerPartNumberReducer";
import DepartmentReducer from "@tCooneyBrothers/Store/Data/Department/DepartmentReducer";
import ProductCarouselTypeReducer from "@tCooneyBrothers/Store/Data/ProductCarouselType/ProductCarouselTypeReducer";
import ProductSelectionPartsReducer from "@tCooneyBrothers/Store/Data/ProductSelectionParts/ProductSelectionPartsReducer";
import UserDetailsReducer from "@tCooneyBrothers/Store/Data/UserDetails/UserDetailsReducer";
import { combineReducers } from "redux";

const dataReducers = {
    departments: DepartmentReducer,
    customerPartNumber: CustomerPartNumberReducer,
    userDetails: UserDetailsReducer,
    productSelectionParts: ProductSelectionPartsReducer,
    productCarouselType: ProductCarouselTypeReducer,
    brandForm: BrandFormReducer
};

export type DataReducers = typeof dataReducers;

const dataReducer = combineReducers(dataReducers as any);

export default dataReducer;
